import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useSettings } from "../context/SettingsContext";

/**
 * Injects Google Analytics 4 (gtag.js) when a measurement ID is configured
 * in Settings. Automatically fires `page_view` on route changes.
 */
export default function Analytics() {
  const { settings } = useSettings();
  const id = (settings.ga4_measurement_id || "").trim();
  const location = useLocation();

  // Load gtag.js once when the ID becomes available
  useEffect(() => {
    if (!id) return;
    if (document.getElementById("ga4-lib")) return;

    const s = document.createElement("script");
    s.id = "ga4-lib";
    s.async = true;
    s.src = `https://www.googletagmanager.com/gtag/js?id=${id}`;
    document.head.appendChild(s);

    window.dataLayer = window.dataLayer || [];
    // eslint-disable-next-line prefer-rest-params
    window.gtag = function () { window.dataLayer.push(arguments); };
    window.gtag("js", new Date());
    window.gtag("config", id, { send_page_view: false });
  }, [id]);

  // Fire page_view on route changes
  useEffect(() => {
    if (!id || typeof window.gtag !== "function") return;
    const path = location.pathname + location.search;
    window.gtag("event", "page_view", {
      page_path: path,
      page_location: window.location.href,
      page_title: document.title,
      send_to: id,
    });
  }, [id, location.pathname, location.search]);

  return null;
}
